import React from 'react';

export type TranslationMode = 'classic' | 'modern' | 'both';

interface TranslationToggleProps {
  mode: TranslationMode;
  onChange: (mode: TranslationMode) => void;
  availableTranslations: string[];
}

const OPTIONS: { value: TranslationMode; label: string }[] = [
  { value: 'classic', label: 'Classic' },
  { value: 'modern', label: 'Modern' },
  { value: 'both', label: 'Both' },
];

const TranslationToggle: React.FC<TranslationToggleProps> = ({
  mode,
  onChange,
  availableTranslations,
}) => {
  if (!availableTranslations || availableTranslations.length <= 1) return null;

  return (
    <div className="inline-flex rounded-lg p-0.5" style={{ background: '#282828' }}>
      {OPTIONS.map((opt) => {
        const isActive = mode === opt.value;
        return (
          <button
            key={opt.value}
            onClick={() => onChange(opt.value)}
            className={`px-4 py-1.5 text-sm font-medium rounded-md transition-all duration-200 ${
              isActive
                ? 'text-white shadow-sm'
                : 'text-[#a7a7a7] hover:text-white'
            }`}
            style={isActive ? { background: 'var(--accent-primary)' } : {}}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
};

export default TranslationToggle;
